import React, { useEffect, useState } from 'react'

import {
  TableFooter,
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled
} from 'components'
import { DeleteIcon, EditIcon } from 'components/Icons'
import { TipoPendencia } from 'utils/types'

interface ITablePendingItems {
  tableData: TipoPendencia[]
  handleOpenDeleteModal: (id: number) => void
  selectedPending: (pending: TipoPendencia) => void
}

export const TablePendingItems = ({
  tableData,
  handleOpenDeleteModal,
  selectedPending
}: ITablePendingItems) => {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(15)

  const handleChangePage = (newPage: number) => setPage(newPage)

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  useEffect(() => {
    setPage(0)
  }, [tableData])

  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled minwidth="35px" align="left" style={{ paddingLeft: "1.3rem" }}>
                Cód.
              </TableCellStyled>
              <TableCellStyled minwidth="100px" align="center">
                Tipo
              </TableCellStyled>
              <TableCellStyled minwidth="250px" align="center">
                Pendência
              </TableCellStyled>
              <TableCellStyled align="center" width='60px'>
                Ações
              </TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {(rowsPerPage > 0
              ? tableData?.slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage
              )
              : tableData
            )?.map((row) => (
              <TableRowStyled key={row.idTipoPendencia}>
                <TableCellStyled align="left" style={{ paddingLeft: '1.5rem' }}>
                  {row.idTipoPendencia}
                </TableCellStyled>
                <TableCellStyled align="center">{row.txTipo}</TableCellStyled>
                <TableCellStyled align="center">
                  {row.txDescricao}
                </TableCellStyled>
                <TableCellStyled align="center">
                  <EditIcon
                    onClick={() => selectedPending(row)}
                    cursor="pointer"
                  />
                  <DeleteIcon
                    cursor="pointer"
                    onClick={() => {
                      handleOpenDeleteModal(row.idTipoPendencia)
                    }}
                  />
                </TableCellStyled>
              </TableRowStyled>
            ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={page}
        rows={tableData}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        typeFooter="offline"
      />
    </>
  )
}
